import CountryPageRenderer from '../components/CountryPageRenderer';
import mexicoData from '../data/country-pages/mexico';

export default function MexicoCountryPage() {
  return <CountryPageRenderer data={mexicoData} />;
}
